/**
 * File email-capture.js.
 * Handles email capture form submit redirecting user to enrollment
 * Handles sending Segment events for email capture form submissions
 * Handles logic for email validation
 */

function emailCaptureInit($) {
  const emailInput = $('input[type="email"]');
  const form = $('.enroll-form');
  
  // If email exists and is invalid, show error message and disable button
  function emailValidationMessage(input, emailInputSubmitEl, emailInputErrorEl) {
    var emailAddress = input.val();
    if (!validateEmail(emailAddress) && emailAddress != '' ) {
      emailInputSubmitEl.attr('disabled', true);
      emailInputErrorEl.show()
                       .html('Please Enter a Valid Email Address');
      emailInput.addClass('email-capture__input--invalid');
    }
  }
  
  // If email is valid or if field is empty, hide message and enable button
  function emailValidation(input, emailInputSubmitEl, emailInputErrorEl) {
    var emailAddress = input.val();
    if (validateEmail(emailAddress) || emailAddress == '') {
      emailInput.removeClass('email-capture__input--invalid');
      emailInputErrorEl.hide();
      emailInputSubmitEl.attr('disabled', false);
    }
  }

  // Handle form submission via anchor for both desktop and mobile
  $('.email-capture__submit').on('click touchend', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('disabled')) {
      $(this).closest('form').submit();
    }
  });

  form.on("submit", function(e) {
    e.preventDefault();

    const pageUrl = getPath();
    const pageId = getReferralId();
    const referralPath = (pageId != '') ? pageUrl.split('/') : [];
    let enrollUrl = getEnrollLink();
    
    let token = null;
    if(referralPath.length >= 2) {
      token = referralPath[2] == 'a' ? referralPath[3] : referralPath[2];
    }

    // get email value
    var email = $(this).find('.email-capture__input').first().val();

    // set encoded email value to a cookie
    document.cookie = "landing_email=" + encodeURIComponent(email) + ";domain=" + globalCookieDomain + ";path=/;";
    
    // get list of search params
    const searchList = getSearchList(token, pageId);
    
    // foreach param in url 
    let paramsArray = getParamsArray(searchList);
    
    function addHiddenParam(input) {
      let hiddenTokenName = input.attr('name');
      let hiddenTokenVal = input.val();
  
      if (hiddenTokenVal) {
        removeParam(paramsArray, hiddenTokenName);
        paramsArray.push(hiddenTokenName + '=' + hiddenTokenVal);
      }
    }

    // if form has .hidden_token field
    const hiddenToken = $(this).find('.hidden_token');
    if (hiddenToken.length) {
      addHiddenParam(hiddenToken);
    }
    
    // if referral page, add referral params
    addTokenQSPs(paramsArray, token, pageId);
    
    const hiddenPromo = $(this).find('.hidden_promo');
    if (hiddenPromo.length) {
      for (let i = 0; i < hiddenPromo.length; i++) {
        addHiddenParam(hiddenPromo.eq(i));
      }
    }
    
    // join unique params
    let queryString = getDistinctQueryString(paramsArray);
    
    // store ignored params
    var ignoredArray = [];
    for (const [key, value] of globalSearchParams.entries()) {
      if (paramsArray.indexOf(`${key}=${value}`) == -1) {
        ignoredArray.push(`${key}=${value}`);
      }
    }
    
    // generate enroll url
    if (queryString) enrollUrl += '?' + queryString;
    const goToEnrollment = redirect(enrollUrl);

    // trigger segment event 'Enter Enrollment CTA Tapped', then redirect page to enrollment
    const ctaLocation = window.location.href;
    const ctaText = $(this).find('.email-capture-submit').text();
    const ctaDestination = $(this).attr('data-action');
    const emailEntered = email !== '';
    const ctaEmail = emailEntered ? email  : null;
    // set button location as hero, bottom, or communication based on form parents
    let btnLocation = ($(this).closest('.header').length > 0) ? 'header' :
                      ($(this).closest('.hero, .referral, .landing-page').length > 0) ? 'hero' :
                      ($(this).closest('.switch').length > 0) ? 'bottom' : 
                      'communication';

    const user_alias = {
      alias_label: "pre_enrollment",
      alias_name: ctaEmail
    }
    
    const moduleAttributes
      = getModuleTrackingAttributes(e.target);

    const moduleData = extractModuleData(moduleAttributes);

    const additionalData = [
      ...moduleAttributes, 
      { key: 'destination', value: ctaDestination },
      { key: 'label', value: ctaText},
      { key: 'cta_type', value: 'enrollment' }
    ];

    const properties = {
      location: ctaLocation,
      button_location: btnLocation,
      email_entered: emailEntered,
      email: ctaEmail,
      ignored_qsps: ignoredArray.join('&'),
      user_alias,
      additional_data: additionalData,
      interaction_details: {
        location: ctaLocation,
        action_detail: ctaText,
      },
    };

    // Pass CTA tapped message to tags.chime.com iframe
    firePostMessageEvent('tags.enter_enrollment_cta_tapped');

    segmentGenericEvent("track", {
      interaction_type: "INTERACTION_TYPE_ENTER_ENROLLMENT_CTA_TAPPED",
      interaction_details: {
        location: ctaLocation,
        action_detail: ctaText
      },
      ...properties
    }, () => null);
    
    segment(
      'identify', 
      'Enter Enrollment CTA Tapped', 
      { status: 'needs_enrollment', completed_first_step: true, email: ctaEmail, user_alias }, 
      goToEnrollment
    );

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebItemClicked, {
      unique_id: 'enrollment_cta_tapped',
      label: ctaText,
      element_type: 'ELEMENT_TYPE_BUTTON',
      item_value: ctaDestination,
      item_details: {
        "enrollment_cta_tapped": {
          "module": {
            ...moduleData,
          },
          "cta_type": 'enrollment',
          "button_location": ctaLocation,
        }
      }
    });
  });


  // Inits
  emailInput.each(function() {
    const $this = $(this);
    const emailInputSubmitEl = $this.parents('.email-capture').find('.email-capture-submit');
    const emailInputErrorEl = $this.parents('.email-capture').find('.email-capture-error');
    $this.on('blur', function(){emailValidationMessage($this, emailInputSubmitEl, emailInputErrorEl)})
         .on('keyup input', function(){emailValidation($this, emailInputSubmitEl, emailInputErrorEl)});
  });
}
